/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function _$$(element, explicit) {
  const QSA = document.querySelectorAll(element);
  if (QSA.length === 1 || explicit) {
    return QSA[0];
  } else if (QSA.length > 1) {
    return QSA;
  } else {
    return null;
  }
}

function stickyAddtocart(){
  
 const stickyContainer = document.querySelector('.ProductForm__BuyButtons');
 let footer = document.getElementById('section-footer');
  if(!stickyContainer) return;
  
  const observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.1
  });
  
  observer.observe(document.querySelector('.ProductForm__BuyButtons'));
  
  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.isIntersecting.id !== footer) {
        stickyContainer.classList.remove('sticky_on');
      }
      else {
        stickyContainer.classList.add('sticky_on');
      }
    })
  }
}


function createElement(element, attributes) {
  let elem = document.createElement(element);
  if (attributes instanceof Object && attributes.constructor === Object) {
    for (let [key, value] of Object.entries(attributes)) {
      elem.setAttribute(key, value);
    }
  }
  return elem;
}

function productProps() {
  if (!_$$(".ProductForm")) return;

  let form = _$$(".ProductForm .ProductForm__QuantitySelector");

  let customProps =
    '<div class="Custom_Properties"><label for="alter-length"><input id="alter-length" type="checkbox">Alter Length</label><div class="prop-input"><input type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxLength="5" style="display:none;" class="alter-length" name="properties[Alter-length]" placeholder="Enter the length in inches"></div>';

  form.insertAdjacentHTML("beforeend", customProps);

  _$$('[for="alter-length"]').addEventListener("click", function () {
    let input = this.querySelector("input");
    if (!input) return;

    let alterinput = this.closest(".Custom_Properties").querySelector(
      '[name="properties[Alter-length]"]'
    );
    if (input.checked) {
      alterinput.style.display = "block";
    } else {
      alterinput.style.display = "none";
    }
  });
}

function collectionInfinte() {
  let ProductList = _$$("#ProductContainer", true);

  if (!ProductList) return;

  initAjaxinate();
}

document.addEventListener('collection:reload', function(){
  initAjaxinate();
})

function initAjaxinate(){
  new Ajaxinate({
    container: '#ProductContainer',
    pagination: '#infiniteScroll'
  });
}

if(document.querySelector('.shipping-tab .tab-title')) {
  document.querySelector('.shipping-tab .tab-title').addEventListener('click', function(){
  if (this.nextElementSibling.offsetHeight === 0) {
    this.nextElementSibling.style.height = '70px';
    this.nextElementSibling.style.paddingTop = '20px';
    this.nextElementSibling.style.paddingBottom = '20px';
  } else {
    this.nextElementSibling.style.height = '0';
    this.nextElementSibling.style.paddingTop = '0';
    this.nextElementSibling.style.paddingBottom = '0';
  }
 });
}


document.addEventListener("DOMContentLoaded", function () {
  productProps();
  collectionInfinte();
  stickyAddtocart();
}); // DOMContentLoaded End







// Couture template //



  
// var elem = document.querySelector('.carousel');
// var flkty = new Flickity(elem, {
//   wrapAround: true,
//   autoPlay: 3000,
//   prevNextButtons: true,
//   pageDots: false
// });

// var totalSlides = flkty.slides.length;

// var pagination = document.querySelector('.custom-pagination');
// pagination.textContent = `1/${totalSlides}`; 

// flkty.on('change', function(index) {

//   setTimeout(function() {
//     pagination.textContent = `${index + 1}/${totalSlides}`;  
//   }, 100); 
// });

